import { CloseFill18Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DropsButton, Flex, Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

type SearchResultTextProps = {
  searchHits: number;
  cancelSearch: () => void;
};

export const SearchResultText: FC<SearchResultTextProps> = ({
  searchHits,
  cancelSearch,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Text variant="xs" color={theme.colorTextSecondary}>
        {searchHits} treff
      </Text>
      <DropsButton
        size="xs"
        variant="ghost"
        fontWeight="400"
        rightIcon={<CloseFill18Icon m="auto" />}
        onClick={cancelSearch}
      >
        {t("Nullstill søk")}
      </DropsButton>
    </Flex>
  );
};
